import React from 'react';
import { Text } from '@fragments';
import Parser from '@helpers/parser';
import { getChargebackEvent, getActorLabel } from '../../../enums/chargebackEvents';
import './styles.scss';

function TimelineDot({ color, Icon }) {
    return (
        <div className={`timeline-dot timeline-dot--${color}`}>
            {Icon && <Icon style={{ fontSize: 11 }} />}
        </div>
    );
}

function TimelineItem({ event, isLast }) {
    const config = getChargebackEvent(event.type);
    const Icon = config.icon;
    const actorLabel = getActorLabel(event.actor);
    const dateStr = Parser.date.readable(event.timestamps?.created);

    return (
        <div className="event-timeline__item">
            <div className="event-timeline__track">
                <TimelineDot color={config.color} Icon={Icon} />
                {!isLast && <div className="event-timeline__connector" />}
            </div>
            <div className="event-timeline__content">
                <Text.span contrast={7} weight={400}>{config.label}</Text.span>
                <div className="event-timeline__meta">
                    {actorLabel && (
                        <Text.small contrast={5} weight={200} className="event-timeline__actor">
                            {actorLabel}
                        </Text.small>
                    )}
                    <Text.small contrast={5} weight={200} className="event-timeline__date">
                        {dateStr}
                    </Text.small>
                </div>
            </div>
        </div>
    );
}

export default function EventTimeline({ events }) {
    if (!events || events.length === 0) return null;

    const sorted = [...events].sort(
        (a, b) => new Date(b.timestamps?.created) - new Date(a.timestamps?.created)
    );

    return (
        <div className="event-timeline">
            <Text.h4 className="event-timeline__title" weight={400}>Atividade recente</Text.h4>
            <div className="event-timeline__list">
                {sorted.map((event, index) => (
                    <TimelineItem
                        key={event.id}
                        event={event}
                        isLast={index === sorted.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}
